import React from 'react';

import SingleContact from './SingleContact';

const RenderSingle = (props) => {
    const renderPosts = (posts) => {
        const post = posts[0];
        if (props.posts.fetched) {
            let hasFeaturedImage = null;
            if (post.better_featured_image) {
                hasFeaturedImage =
                    post.better_featured_image.media_details.sizes;
            }
            return (
                <SingleContact
                    key={post.id}
                    acf={post.acf || []}
                    type={post.type}
                    pId={post.id}
                    title={post.title.rendered}
                    content={post.content.rendered}
                    date={post.date}
                    formattedDate={post.formatted_date}
                    link={post.link}
                    featuredImage={hasFeaturedImage}
                    categories={post.categories}
                    tags={post.tags || []}
                    links={post._links}
                />
            );
        }
    };

    return <div>{renderPosts(props.posts.posts)}</div>;
};

export default RenderSingle;



// WEBPACK FOOTER //
// ./src/components/Pages/RenderContact.jsx